<template>
	<path
		id="Vector"
		d="M5.43431 13.7314L0.234305 8.53136C-0.0781016 8.21895 -0.0781016 7.71242 0.234305 7.39998L1.36565 6.26861C1.67805 5.95617 2.18462 5.95617 2.49702 6.26861L5.99999 9.77154L13.503 2.26861C13.8154 1.9562 14.3219 1.9562 14.6343 2.26861L15.7657 3.39998C16.0781 3.71239 16.0781 4.21892 15.7657 4.53136L6.56568 13.7314C6.25324 14.0438 5.74671 14.0438 5.43431 13.7314Z"
		fill="#E2E2E2"
	/>
</template>
